
import React from 'react';
import { Table, TableHeader, TableBody, TableHead, TableRow, TableCell } from '@/components/ui/table';
import { Button } from '@/components/ui/button';
import { User } from '@/types/userRole';
import { formatDistanceToNow } from 'date-fns';
import { CheckCircle, XCircle, Power, PowerOff } from 'lucide-react';

interface ManagersTableProps {
  managers: User[];
  onDeactivate: (managerId: string) => Promise<void>;
  onReactivate: (managerId: string) => Promise<void>;
}

const ManagersTable: React.FC<ManagersTableProps> = ({ 
  managers, 
  onDeactivate,
  onReactivate 
}) => {
  return (
    <div className="rounded-md border overflow-hidden">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Name</TableHead>
            <TableHead>Email</TableHead>
            <TableHead>Status</TableHead>
            <TableHead>Last Login</TableHead>
            <TableHead className="w-[100px]">Actions</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {managers.length === 0 ? (
            <TableRow>
              <TableCell colSpan={5} className="text-center py-8 text-muted-foreground">
                No managers found
              </TableCell>
            </TableRow>
          ) : (
            managers.map((manager) => (
              <TableRow key={manager.id}>
                <TableCell className="font-medium">{manager.name}</TableCell>
                <TableCell>{manager.email}</TableCell>
                <TableCell>
                  {manager.isActive !== false ? (
                    <span className="flex items-center text-green-600">
                      <CheckCircle className="h-4 w-4 mr-1" /> Active
                    </span>
                  ) : (
                    <span className="flex items-center text-gray-500">
                      <XCircle className="h-4 w-4 mr-1" /> Inactive
                    </span>
                  )}
                </TableCell>
                <TableCell>
                  {manager.lastLogin 
                    ? `${formatDistanceToNow(new Date(manager.lastLogin))} ago`
                    : "Never"}
                </TableCell>
                <TableCell>
                  {manager.isActive !== false ? (
                    <Button
                      variant="ghost"
                      size="sm"
                      onClick={() => onDeactivate(manager.id)}
                      className="text-destructive hover:text-destructive"
                    >
                      <Power className="h-4 w-4" />
                      <span className="sr-only">Deactivate</span>
                    </Button>
                  ) : (
                    <Button
                      variant="ghost"
                      size="sm"
                      onClick={() => onReactivate(manager.id)}
                      className="text-primary hover:text-primary"
                    >
                      <PowerOff className="h-4 w-4" />
                      <span className="sr-only">Reactivate</span>
                    </Button>
                  )}
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </div>
  );
};

export default ManagersTable;
